<template>
  <div id="app">
    <img src="./assets/grh.png" width="120" height="120">
		<p>果然好商城</p>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

*{
	margin: 0px;
	padding: 0px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
	height: 100%;
  width: 100%;
}

body {
	background: url(./assets/背景.png) no-repeat center;
	background-size: cover;
	height: 100vh;
	width: 100%;
	margin: 0;
	/* viewport-fix:cover; */
}

img {

	margin-top: 204px;
}

p {

	font-size: 20px;
}

button {

	margin-top: 50px;
	border: 0;
	border-radius: 8px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue